import { render, staticRenderFns } from "./CodeEditor.vue?vue&type=template&id=6c0b5404&scoped=true"
import script from "./CodeEditor.vue?vue&type=script&lang=js"
export * from "./CodeEditor.vue?vue&type=script&lang=js"
import style0 from "./CodeEditor.vue?vue&type=style&index=0&id=6c0b5404&prod&lang=scss"
import style1 from "./CodeEditor.vue?vue&type=style&index=1&id=6c0b5404&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0b5404",
  null
  
)

export default component.exports